<template>
  <div class="content" v-if="rendered">
    <div class="loading-overlay" :class="show ? 'is-active' : ''">
      <span class="fas fa-spinner fa-3x fa-spin"></span>
    </div>
    <div class="card marineBg titulo p-5">
      <div class="row">
        <div class="col text-left">
          <h2>Filtrar por atividade</h2>
        </div>
        <div class="col text-right">
          <base-button
            @click="limparFiltros()"
            class="mb-3 bg_edp_verde"
            size="lg"
            simple
          >
            Limpar Filtros
          </base-button>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-6">
          <h3 class="text-left">TRIBO TERRA</h3>
          <div class="row">
            <el-select
              class="select-primary mb-3 pagination-select"
              placeholder="10 Horas"
              v-model="escolhidoGrupo1_10"
              @change="filtrarTabela('1', '10')"
            >
              <el-option
                class="select-primary"
                v-for="(item, i) in atividadesGrupo1_10"
                :key="i"
                :label="item.nome + ' - ' + item.hora + 'h'"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="row">
            <el-select
              class="select-primary mb-3 pagination-select"
              placeholder="11 Horas"
              v-model="escolhidoGrupo1_11"
              @change="filtrarTabela('1', '11')"
            >
              <el-option
                class="select-primary"
                v-for="(item, i) in atividadesGrupo1_11"
                :key="i"
                :label="item.nome + ' - ' + item.hora + 'h'"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="row">
            <el-select
              class="select-primary mb-3 pagination-select"
              placeholder="12 Horas"
              v-model="escolhidoGrupo1_12"
              @change="filtrarTabela('1', '12')"
            >
              <el-option
                class="select-primary"
                v-for="(item, i) in atividadesGrupo1_12"
                :key="i"
                :label="item.nome + ' - ' + item.hora + 'h'"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="col-6">
          <h3 class="text-left">TRIBO ÁGUA</h3>
          <div class="row">
            <el-select
              class="select-primary mb-3 pagination-select"
              placeholder="10 Horas"
              v-model="escolhidoGrupo2_10"
              @change="filtrarTabela('2', '10')"
            >
              <el-option
                class="select-primary"
                v-for="(item, i) in atividadesGrupo2_10"
                :key="i"
                :label="item.nome + ' - ' + item.hora + 'h'"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="row">
            <el-select
              class="select-primary mb-3 pagination-select"
              placeholder="11 Horas"
              v-model="escolhidoGrupo2_11"
              @change="filtrarTabela('2', '11')"
            >
              <el-option
                class="select-primary"
                v-for="(item, i) in atividadesGrupo2_11"
                :key="i"
                :label="item.nome + ' - ' + item.hora + 'h'"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="row">
            <el-select
              class="select-primary mb-3 pagination-select"
              placeholder="12 Horas"
              v-model="escolhidoGrupo2_12"
              @change="filtrarTabela('2', '12')"
            >
              <el-option
                class="select-primary"
                v-for="(item, i) in atividadesGrupo2_12"
                :key="i"
                :label="item.nome + ' - ' + item.hora + 'h'"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="row" v-if="filtrado1">
        <div class="col">
          <el-table :data="queriedData">
            <el-table-column :min-width="150" label="Nome">
              <div slot-scope="props">
                {{ props.row.nome }}
              </div>
            </el-table-column>
            <el-table-column :min-width="150" label="Presença">
              <div slot-scope="props">
                <div v-if="escolhidoGrupo1_10 != ''">
                  <el-select
                    class="select-info"
                    size="large"
                    v-model="props.row.pontos[escolhidoGrupo1_10].presente"
                    collapse-tags
                    placeholder="Presente?"
                    @change="mudarPontos(props.row.pontos, props.row)"
                  >
                    <el-option
                      v-for="option in selectPresenca"
                      class="select-info"
                      :value="option.value"
                      :label="option.label"
                      :key="option.label"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div v-if="escolhidoGrupo1_11 != ''">
                  <el-select
                    class="select-info"
                    size="large"
                    v-model="props.row.pontos[escolhidoGrupo1_11].presente"
                    collapse-tags
                    placeholder="Presente?"
                    @change="mudarPontos(props.row.pontos, props.row)"
                  >
                    <el-option
                      v-for="option in selectPresenca"
                      class="select-info"
                      :value="option.value"
                      :label="option.label"
                      :key="option.label"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div v-if="escolhidoGrupo1_12 != ''">
                  <el-select
                    class="select-info"
                    size="large"
                    v-model="props.row.pontos[escolhidoGrupo1_12].presente"
                    collapse-tags
                    placeholder="Presente?"
                    @change="mudarPontos(props.row.pontos, props.row)"
                  >
                    <el-option
                      v-for="option in selectPresenca"
                      class="select-info"
                      :value="option.value"
                      :label="option.label"
                      :key="option.label"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </el-table-column>
            <el-table-column :min-width="150" label="Pontos">
              <div slot-scope="props">
                <div v-if="escolhidoGrupo1_10 != ''">
                  <el-select
                    class="select-info"
                    size="large"
                    placeholder="Classificação"
                    v-model="props.row.pontos[escolhidoGrupo1_10].pontos"
                    @change="mudarPontos(props.row.pontos, props.row)"
                  >
                    <el-option
                      v-for="option in selectPontos"
                      class="select-info"
                      :value="option.value"
                      :label="option.label"
                      :key="option.label"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div v-if="escolhidoGrupo1_11 != ''">
                  <el-select
                    class="select-info"
                    size="large"
                    placeholder="Classificação"
                    v-model="props.row.pontos[escolhidoGrupo1_11].pontos"
                    @change="mudarPontos(props.row.pontos, props.row)"
                  >
                    <el-option
                      v-for="option in selectPontos"
                      class="select-info"
                      :value="option.value"
                      :label="option.label"
                      :key="option.label"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div v-if="escolhidoGrupo1_12 != ''">
                  <el-select
                    class="select-info"
                    size="large"
                    placeholder="Classificação"
                    v-model="props.row.pontos[escolhidoGrupo1_12].pontos"
                    @change="mudarPontos(props.row.pontos, props.row)"
                  >
                    <el-option
                      v-for="option in selectPontos"
                      class="select-info"
                      :value="option.value"
                      :label="option.label"
                      :key="option.label"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="row" v-if="filtrado2">
        <div class="col">
          <el-table :data="queriedData">
            <el-table-column :min-width="150" label="Nome">
              <div slot-scope="props">
                {{ props.row.nome }}
              </div>
            </el-table-column>
            <el-table-column :min-width="150" label="Presença">
              <div slot-scope="props">
                <div v-if="escolhidoGrupo2_10 != ''">
                  <el-select
                    class="select-info"
                    size="large"
                    v-model="props.row.pontos[escolhidoGrupo2_10].presente"
                    collapse-tags
                    placeholder="Presente?"
                    @change="mudarPontos(props.row.pontos, props.row)"
                  >
                    <el-option
                      v-for="option in selectPresenca"
                      class="select-info"
                      :value="option.value"
                      :label="option.label"
                      :key="option.label"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div v-if="escolhidoGrupo2_11 != ''">
                  <el-select
                    class="select-info"
                    size="large"
                    v-model="props.row.pontos[escolhidoGrupo2_11].presente"
                    collapse-tags
                    placeholder="Presente?"
                    @change="mudarPontos(props.row.pontos, props.row)"
                  >
                    <el-option
                      v-for="option in selectPresenca"
                      class="select-info"
                      :value="option.value"
                      :label="option.label"
                      :key="option.label"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div v-if="escolhidoGrupo2_12 != ''">
                  <el-select
                    class="select-info"
                    size="large"
                    v-model="props.row.pontos[escolhidoGrupo2_12].presente"
                    collapse-tags
                    placeholder="Presente?"
                    @change="mudarPontos(props.row.pontos, props.row)"
                  >
                    <el-option
                      v-for="option in selectPresenca"
                      class="select-info"
                      :value="option.value"
                      :label="option.label"
                      :key="option.label"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </el-table-column>
            <el-table-column :min-width="150" label="Pontos">
              <div slot-scope="props">
                <div v-if="escolhidoGrupo2_10 != ''">
                  <el-select
                    class="select-info"
                    size="large"
                    placeholder="Classificação"
                    v-model="props.row.pontos[escolhidoGrupo2_10].pontos"
                    @change="mudarPontos(props.row.pontos, props.row)"
                  >
                    <el-option
                      v-for="option in selectPontos"
                      class="select-info"
                      :value="option.value"
                      :label="option.label"
                      :key="option.label"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div v-if="escolhidoGrupo2_11 != ''">
                  <el-select
                    class="select-info"
                    size="large"
                    placeholder="Classificação"
                    v-model="props.row.pontos[escolhidoGrupo2_11].pontos"
                    @change="mudarPontos(props.row.pontos, props.row)"
                  >
                    <el-option
                      v-for="option in selectPontos"
                      class="select-info"
                      :value="option.value"
                      :label="option.label"
                      :key="option.label"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div v-if="escolhidoGrupo2_12 != ''">
                  <el-select
                    class="select-info"
                    size="large"
                    placeholder="Classificação"
                    v-model="props.row.pontos[escolhidoGrupo2_12].pontos"
                    @change="mudarPontos(props.row.pontos, props.row)"
                  >
                    <el-option
                      v-for="option in selectPontos"
                      class="select-info"
                      :value="option.value"
                      :label="option.label"
                      :key="option.label"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { Card, BasePagination, BaseInput, Modal } from "@/components/index";
  import { Table, TableColumn, Select, Option } from "element-ui";
  import swal from "sweetalert2";
  import Fuse from "fuse.js";
  import api from "@/api/index";
  export default {
    components: {
      Card,
      [Select.name]: Select,
      [Option.name]: Option,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      BasePagination,
      BaseInput,
      Modal,
    },
    data() {
      return {
        arrayVazia: [],
        teste: "",
        selectPontos: [
          {
            label: "Não concluiu - 0 Pontos",
            value: "0",
          },
          {
            label: "Concluiu - 1 Ponto",
            value: "1",
          },
          {
            label: "Concluiu com mérito - 2 Pontos",
            value: "2",
          },
        ],
        selectPresenca: [
          {
            label: "Não",
            value: "nao",
          },
          {
            label: "Sim",
            value: "sim",
          },
        ],
        filtrado1: false,
        filtrado2: false,
        show: true,
        atividadesGrupo1_10: [],
        atividadesGrupo2_10: [],
        atividadesGrupo1_11: [],
        atividadesGrupo2_11: [],
        atividadesGrupo1_12: [],
        atividadesGrupo2_12: [],
        escolhidoGrupo1_10: "",
        escolhidoGrupo2_10: "",
        escolhidoGrupo1_11: "",
        escolhidoGrupo2_11: "",
        escolhidoGrupo1_12: "",
        escolhidoGrupo2_12: "",
        rendered: false,
        searchQuery: "",
        propsToSearch: ["nome", "apelido", "email", "consultor"],
        pagination: {
          perPage: 100,
          currentPage: 1,
          perPageOptions: [50, 100, 200, 400, 600],
          total: 0,
        },
        searchedData: [],
        tableData: [],
        tableDataBU: [],
        utilizadores: [],
      };
    },
    methods: {
      async mudarPontos(json, array) {
        this.show = true;
        var pontos = JSON.stringify(json);
        let jsonAtualizarPontos = {
          user_id: array.user_id,
          pontos: pontos,
        };
        await api.atribuirPontos(jsonAtualizarPontos);
        this.show = false;
      },
      limparFiltros() {
        this.escolhidoGrupo1_10 = "";
        this.escolhidoGrupo1_11 = "";
        this.escolhidoGrupo1_12 = "";
        this.escolhidoGrupo2_10 = "";
        this.escolhidoGrupo2_11 = "";
        this.escolhidoGrupo2_12 = "";
      },
      filtrarTabela(grupo, hora) {
        if (grupo == "1") {
          this.escolhidoGrupo2_10 = "";
          this.escolhidoGrupo2_11 = "";
          this.escolhidoGrupo2_12 = "";
          if (hora == "10") {
            this.escolhidoGrupo1_11 = "";
            this.escolhidoGrupo1_12 = "";
          } else if (hora == "11") {
            this.escolhidoGrupo1_10 = "";
            this.escolhidoGrupo1_12 = "";
          } else {
            this.escolhidoGrupo1_11 = "";
            this.escolhidoGrupo1_10 = "";
          }

          if (this.escolhidoGrupo1_10 != "") {
            this.tableData = this.tableDataBU.filter(
              (x) =>
                x.atividades.indexOf(this.escolhidoGrupo1_10.toString()) > -1
            );
            if (this.tableData.length > 0) {
              this.filtrado2 = false;
              this.filtrado1 = true;
            } else {
              this.filtrado2 = false;
              this.filtrado1 = false;
              this.naoEncontrado = true;
            }
          } else if (this.escolhidoGrupo1_11 != "") {
            this.tableData = this.tableDataBU.filter(
              (x) =>
                x.atividades.indexOf(this.escolhidoGrupo1_11.toString()) > -1
            );
            if (this.tableData.length > 0) {
              this.filtrado2 = false;
              this.filtrado1 = true;
            } else {
              this.filtrado2 = false;
              this.filtrado1 = false;
              this.naoEncontrado = true;
            }
          } else {
            this.tableData = this.tableDataBU.filter(
              (x) =>
                x.atividades.indexOf(this.escolhidoGrupo1_12.toString()) > -1
            );
            if (this.tableData.length > 0) {
              this.filtrado2 = false;
              this.filtrado1 = true;
            } else {
              this.filtrado2 = false;
              this.filtrado1 = false;
              this.naoEncontrado = true;
            }
          }
        } else {
          this.escolhidoGrupo1_10 = "";
          this.escolhidoGrupo1_11 = "";
          this.escolhidoGrupo1_12 = "";

          if (hora == "10") {
            this.escolhidoGrupo2_11 = "";
            this.escolhidoGrupo2_12 = "";
          } else if (hora == "11") {
            this.escolhidoGrupo2_10 = "";
            this.escolhidoGrupo2_12 = "";
          } else {
            this.escolhidoGrupo2_11 = "";
            this.escolhidoGrupo2_10 = "";
          }

          if (this.escolhidoGrupo2_10 != "") {
            this.tableData = this.tableDataBU.filter(
              (x) =>
                x.atividades.indexOf(this.escolhidoGrupo2_10.toString()) > -1
            );
            if (this.tableData.length > 0) {
              this.filtrado2 = true;
              this.filtrado1 = false;
            } else {
              this.filtrado2 = false;
              this.filtrado1 = false;
              this.naoEncontrado = true;
            }
          } else if (this.escolhidoGrupo2_11 != "") {
            this.tableData = this.tableDataBU.filter(
              (x) =>
                x.atividades.indexOf(this.escolhidoGrupo2_11.toString()) > -1
            );
            if (this.tableData.length > 0) {
              this.filtrado2 = true;
              this.filtrado1 = false;
            } else {
              this.filtrado2 = false;
              this.filtrado1 = false;
              this.naoEncontrado = true;
            }
          } else {
            this.tableData = this.tableDataBU.filter(
              (x) =>
                x.atividades.indexOf(this.escolhidoGrupo2_12.toString()) > -1
            );
            if (this.tableData.length > 0) {
              this.filtrado2 = true;
              this.filtrado1 = false;
            } else {
              this.filtrado2 = false;
              this.filtrado1 = false;
              this.naoEncontrado = true;
            }
          }
        }
      },
      async inicio() {
        // buscar utilizadores
        let resultadoUtilizadores = await api.buscarDadosTodos();
        resultadoUtilizadores = Object.values(resultadoUtilizadores);

        this.utilizadores = resultadoUtilizadores;

        //buscar atividades
        var jsonGrupo1 = {
          grupo: "1",
        };
        var jsonGrupo2 = {
          grupo: "2",
        };
        let resultadoAtividadesGrupo1 = await api.buscarAtividadesGrupo(
          jsonGrupo1
        );
        let resultadoAtividadesGrupo2 = await api.buscarAtividadesGrupo(
          jsonGrupo2
        );

        resultadoAtividadesGrupo1 = Object.values(resultadoAtividadesGrupo1);
        resultadoAtividadesGrupo2 = Object.values(resultadoAtividadesGrupo2);

        this.atividadesGrupo1_10 = resultadoAtividadesGrupo1.filter(
          (x) => x.hora == "10"
        );
        this.atividadesGrupo2_10 = resultadoAtividadesGrupo2.filter(
          (x) => x.hora == "10"
        );
        this.atividadesGrupo1_11 = resultadoAtividadesGrupo1.filter(
          (x) => x.hora == "11"
        );
        this.atividadesGrupo2_11 = resultadoAtividadesGrupo2.filter(
          (x) => x.hora == "11"
        );
        this.atividadesGrupo1_12 = resultadoAtividadesGrupo1.filter(
          (x) => x.hora == "12"
        );
        this.atividadesGrupo2_12 = resultadoAtividadesGrupo2.filter(
          (x) => x.hora == "12"
        );

        // for (let i = 0; i < this.utilizadores.length; i++) {
        //   if (
        //     this.utilizadores[i].atividades != "" &&
        //     this.utilizadores[i].atividades.length > 0 &&
        //     this.utilizadores[i].atividades
        //   ) {
        //     var temp = this.utilizadores[i].atividades.split(",");
        //     this.utilizadores[i].atividades = this.utilizadores[
        //       i
        //     ].atividades.split(",");
        //     if (temp.length > 0) {
        //       if (
        //         this.utilizadores[i].pontos != "" &&
        //         this.utilizadores[i].pontos
        //       ) {
        //         this.utilizadores[i].pontos = JSON.parse(
        //           this.utilizadores[i].pontos
        //         );
        //       } else {
        //         this.utilizadores[i].pontos = [];
        //         var temp2 = {};
        //         for (let k = 0; k < temp.length; k++) {
        //           temp2[temp[k]] = { pontos: "0", presente: "nao" };
        //         }
        //         this.utilizadores[i].pontos = temp2;
        //       }
        //       this.tableDataBU.push(this.utilizadores[i]);
        //       this.tableData.push(this.utilizadores[i]);
        //     }
        //   }
        // }
        this.show = false;
      },
    },
    async mounted() {
      var user_id = localStorage.getItem("active-session-niu");
      var jsonUser = {
        user_id: user_id,
      };
      let res = await api.buscarDados(jsonUser);
      var user = Object.values(res)[0];
      if (user.nivel == "3") {
        if (user.pontos && user.pontos.length > 4) {
          this.$router.push("/atividades");
          return;
        }
        this.$router.push("/dashboard");
        return;
      }
      this.inicio();
      this.rendered = true;
    },
    computed: {
      queriedData() {
        let result = this.tableData;
        if (this.searchedData.length > 0) {
          result = this.searchedData;
        }
        return result.slice(this.from, this.to);
      },
      to() {
        let highBound = this.from + this.pagination.perPage;
        if (this.total < highBound) {
          highBound = this.total;
        }
        return highBound;
      },
      from() {
        return this.pagination.perPage * (this.pagination.currentPage - 1);
      },
      total() {
        return this.searchedData.length > 0
          ? this.searchedData.length
          : this.tableData.length;
      },
    },
  };
</script>
